var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_946_4193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4236 23.3791C26.9699 24.4272 26.4329 25.392 25.8107 26.279C24.9625 27.4882 24.2681 28.3253 23.733 28.7901C22.9034 29.553 22.0145 29.9437 21.0627 29.9659C20.3794 29.9659 19.5553 29.7715 18.5961 29.3771C17.6337 28.9845 16.7493 28.7901 15.9406 28.7901C15.0925 28.7901 14.1829 28.9845 13.2099 29.3771C12.2355 29.7715 11.4506 29.9771 10.8504 29.9974C9.93763 30.0363 9.02785 29.6345 8.11973 28.7901C7.54011 28.2845 6.81514 27.4179 5.94664 26.1901C5.01482 24.8791 4.24873 23.3587 3.64856 21.6255C3.00581 19.7533 2.68359 17.9404 2.68359 16.1853C2.68359 14.1748 3.11803 12.4407 3.98818 10.9876C4.67205 9.82044 5.58184 8.89973 6.72051 8.22383C7.85918 7.54792 9.08951 7.20349 10.4145 7.18145C11.1395 7.18145 12.0902 7.4057 13.2716 7.84643C14.4497 8.28864 15.2062 8.51289 15.5378 8.51289C15.7858 8.51289 16.6261 8.25068 18.0507 7.72791C19.3979 7.24311 20.5349 7.04238 21.4664 7.12145C23.9904 7.32515 25.8866 8.32012 27.1477 10.1127C24.8903 11.4804 23.7737 13.3961 23.7959 15.8536C23.8163 17.7678 24.5107 19.3607 25.8755 20.6255C26.494 21.2125 27.1847 21.6662 27.9532 21.9884C27.7865 22.4717 27.6106 22.9347 27.4236 23.3791ZM21.6349 0.600167C21.6349 2.10051 21.0867 3.50138 19.9942 4.798C18.6757 6.33944 17.0809 7.23015 15.3515 7.0896C15.3295 6.90961 15.3167 6.72017 15.3167 6.5211C15.3167 5.08077 15.9437 3.53934 17.0572 2.27901C17.6131 1.64088 18.3202 1.11028 19.1775 0.687016C20.0331 0.270066 20.8423 0.0394803 21.6034 0C21.6256 0.200568 21.6349 0.401173 21.6349 0.600167Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_946_4193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.318359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d0936f5e5305e2240179327dfc3f525e.svg";
export { ForwardRef as ReactComponent };